export const GTM_WISHLIST_LIST_NAME = 'wishlist';
export const GTM_WISHLIST_PAGE_TYPE = 'wishlist';
export const WISHLIST_PAGE_SIZE = 8;
